import "../../../../src/content/billy-graham-channel/bgchannel.scss";
import Graphics from "../../../../src/content/billy-graham-channel/graphics";
import * as React from 'react';
export default {
  Graphics,
  React
};